var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 35,
    viewBox: "0 0 29 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.709 7.1529C18.9375 7.15215 18.1978 6.84536 17.6523 6.29984C17.1068 5.75433 16.8 5.01466 16.7993 4.24319V0.20459H3.7973C2.79019 0.20459 1.82434 0.604664 1.11221 1.3168C0.400074 2.02893 0 2.99478 0 4.00189V26.8929C0.00149555 27.8991 0.402226 28.8635 1.1142 29.5744C1.82617 30.2853 2.79117 30.6846 3.7973 30.6846H19.4056C20.412 30.6846 21.3772 30.2851 22.0892 29.5739C22.8012 28.8627 23.2018 27.8979 23.2029 26.8915V7.1529H19.709Z",
    fill: "#005FAD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2025 7.1529H19.7085C18.9371 7.15215 18.1974 6.84536 17.6519 6.29984C17.1064 5.75433 16.7996 5.01466 16.7988 4.24319V0.20459L23.2025 7.1529Z",
    fill: "#005FAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9557 24.2788H8.31117C7.05955 24.2788 6.04492 25.2934 6.04492 26.5451V31.8057C6.04492 33.0573 7.05955 34.0719 8.31117 34.0719H25.9557C27.2073 34.0719 28.2219 33.0573 28.2219 31.8057V26.5451C28.2219 25.2934 27.2073 24.2788 25.9557 24.2788Z",
    fill: "#005FAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8391 27.4467C22.197 27.7379 22.4404 28.1463 22.5263 28.5996H21.4398C21.3665 28.4117 21.2381 28.2504 21.0715 28.1367C20.8958 28.0224 20.6897 27.9639 20.4802 27.9688C20.3419 27.9644 20.2043 27.9919 20.0783 28.0491C19.9523 28.1064 19.8412 28.1919 19.7535 28.299C19.557 28.5504 19.4569 28.8637 19.4713 29.1824C19.4569 29.4998 19.5571 29.8118 19.7535 30.0615C19.8419 30.1675 19.9532 30.252 20.0792 30.3085C20.2051 30.365 20.3423 30.392 20.4802 30.3874C20.6898 30.393 20.8961 30.3345 21.0715 30.2195C21.2372 30.108 21.3655 29.9492 21.4398 29.7637H22.5263C22.439 30.2157 22.1958 30.6228 21.8391 30.9138C21.4553 31.2069 20.9811 31.3566 20.4985 31.3372C20.1183 31.3452 19.743 31.2506 19.412 31.0634C19.1022 30.8833 18.8509 30.6178 18.6881 30.2986C18.5132 29.9484 18.426 29.561 18.4341 29.1697C18.4261 28.7784 18.5133 28.391 18.6881 28.0408C18.8509 27.7216 19.1022 27.456 19.412 27.276C19.743 27.0888 20.1183 26.9942 20.4985 27.0022C20.9836 26.9894 21.4578 27.1466 21.8391 27.4467Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8341 27.2319V31.4752H16.8125V27.2319H17.8341Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0273 29.8511V31.3384H13V27.0952H14.6623C15.1675 27.0952 15.5518 27.2203 15.8152 27.4706C15.9489 27.6017 16.0533 27.7597 16.1217 27.934C16.19 28.1084 16.2207 28.2953 16.2117 28.4823C16.2161 28.7291 16.1548 28.9727 16.0339 29.1879C15.9114 29.3985 15.7285 29.5676 15.509 29.6733C15.2449 29.7992 14.9547 29.8602 14.6623 29.8511H14.0273ZM15.1675 28.4823C15.1675 28.106 14.9615 27.9179 14.5494 27.9179H14.0273V29.0228H14.5494C14.9615 29.0266 15.1675 28.8464 15.1675 28.4823Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7186 9.61865H5.77832V11.5589H7.7186V9.61865Z",
    fill: "#005FAD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66 11.5601H7.71973V13.5003H9.66V11.5601Z",
    fill: "#005FAD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6004 9.61865H9.66016V11.5589H11.6004V9.61865Z",
    fill: "#005FAD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5411 11.5603H11.6008V13.5006H13.5411V11.5603Z",
    fill: "#005FAD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4842 9.61865H13.5439V11.5589H15.4842V9.61865Z",
    fill: "#005FAD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4244 11.5603H15.4841V13.5006H17.4244V11.5603Z",
    fill: "#005FAD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7186 13.4976H5.77832V15.4378H7.7186V13.4976Z",
    fill: "#005FAD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66 15.439H7.71973V17.3792H9.66V15.439Z",
    fill: "#005FAD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6004 13.4976H9.66016V15.4378H11.6004V13.4976Z",
    fill: "#005FAD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5409 15.439H11.6006V17.3792H13.5409V15.439Z",
    fill: "#005FAD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4842 13.4976H13.5439V15.4378H15.4842V13.4976Z",
    fill: "#005FAD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4247 15.439H15.4844V17.3792H17.4247V15.439Z",
    fill: "#005FAD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7186 17.3921H5.77832V19.3324H7.7186V17.3921Z",
    fill: "#005FAD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66 19.3335H7.71973V21.2738H9.66V19.3335Z",
    fill: "#005FAD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6004 17.3921H9.66016V19.3324H11.6004V17.3921Z",
    fill: "#005FAD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5409 19.3335H11.6006V21.2738H13.5409V19.3335Z",
    fill: "#005FAD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4842 17.3921H13.5439V19.3324H15.4842V17.3921Z",
    fill: "#005FAD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4247 19.3335H15.4844V21.2738H17.4247V19.3335Z",
    fill: "#005FAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/PNG.319dc79cfc81523fb1e15ba5fbeeafa3.svg";
export { ForwardRef as ReactComponent };